import { AlertTriangle } from 'lucide-react';
import { useServiceStatus } from '../hooks/useServiceStatus';

/**
 * Shown on the login page and the Support ("Report an Issue") page when
 * StatusAPI reports a degraded service — lets users self-serve ("is it just
 * me?") and, on the Support page, dissuades reporting a known issue. Renders
 * nothing when everything's operational or the status feed itself can't be reached.
 */
export default function StatusBanner() {
  const status = useServiceStatus();

  if (!status || status.overall !== 'degraded') return null;

  const degraded = status.services.filter((s) => s.status === 'degraded');
  if (degraded.length === 0) return null;

  return (
    <div className="flex items-start gap-2 rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300 text-sm px-3 py-2 mb-4">
      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
      <div>
        <p className="font-medium">We're aware of an issue affecting: {degraded.map((s) => s.name).join(', ')}</p>
        <p className="text-xs opacity-80">No need to report it separately — we're on it.</p>
      </div>
    </div>
  );
}
